import { Box, TextField, Typography } from '@mui/material';
import { ChangeEvent, forwardRef, useImperativeHandle, useState } from 'react';
import checkIfEmptyString from '../../../../utils/check-if-empty';

const TemplateNameTextfield = forwardRef((props, ref) => {
  const [templateName, setTemplateName] = useState<string>('');

  useImperativeHandle(ref, () => ({
    getValue: () => templateName,
  }));

  const isEmpty = checkIfEmptyString(templateName);

  return (
    <Box sx={{ width: '100%', mb: '2vh' }}>
      <Typography sx={{ color: isEmpty ? '#ff6b6b' : '#ffffff', fontSize: '0.78rem', mb: 0.5 }}>
        {isEmpty ? 'Type Template Name' : 'Template Name'}
      </Typography>
      <TextField
        error={isEmpty}
        id={isEmpty ? 'outlined-error' : 'outlined-basic'}
        variant='outlined'
        value={templateName}
        placeholder='Type Template Name'
        onChange={(e: ChangeEvent<HTMLInputElement>) => setTemplateName(e.target.value)}
        InputProps={{
          style: {
            width: '100%',
            color: '#ffffff',
          },
        }}
        style={{ width: '100%' }}
      />
    </Box>
  );
});
TemplateNameTextfield.displayName = 'TemplateNameTextfield';

export default TemplateNameTextfield;
